import {css} from 'lit';

export default css`
/** Animating both display and opacity of element in floating env: first set display to block, then animate opacity */
@keyframes showElement {
  0% {
    display: none;
    opacity: 0;
  }
  1% {
    display: inline-block;
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes smallbounce {
  0% {
    bottom: -4px;
  }
  100% {
    bottom: 0;
  }
}

@keyframes bounceX {
  0% {
    right: -2px;
  }
  100% {
    right: 3px;
  }
}

@keyframes moveUp {
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes moveDown {
  100% {
    transform: translateY(200rem);
  }
}


@keyframes slidedown {
  0% {
    top: -5.6rem;
  }
  100% {
    top: 0;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes bouncedelay {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

@keyframes open {
  0% {
    opacity: 0;
    transform: translate3d(calc(-100vw - 50%), 0, 0);
  }
  50% {
    opacity: 1;
    transform: translate3d(100px, 0, 0);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes close {
  0% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  50% {
    opacity: 1;
    transform: translate3d(-100px, 0, 0) scale3d(1.1, 1.1, 1);
  }
  100% {
    opacity: 0;
    transform: translate3d(calc(100vw + 50%), 0, 0);
  }
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  40% {
    opacity: 0;
    transform: scale(0.9);
  }
  80% {
    opacity: 1;
    transform: scale(1.05);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes bounceOut {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  20% {
    opacity: 1;
    transform: scale(1.05);
  }
  50% {
    opacity: 0;
    transform: scale(0.95);
  }
  100% {
    opacity: 0;
    transform: scale(0.95);
  }
}
`;
